import { supabase } from '../lib/supabase'

/**
 * The access token that makes a show link work. Mirrors utils/accessToken.ts
 * exactly, one level up: read only here, only for building the link a staff
 * member copies.
 */

const cache = new Map<string, string>()

export async function fetchShowAccessToken(slug: string, showId = ''): Promise<string> {
  if (!supabase) return ''

  const cached = cache.get(slug)
  if (cached) return cached

  const token = (await lookup('slug', slug)) || (await lookup('id', showId))
  if (token) cache.set(slug, token)
  return token
}

async function lookup(column: 'slug' | 'id', value: string): Promise<string> {
  if (!supabase || !value) return ''

  const { data, error } = await supabase
    .from('shows')
    .select('access_token')
    .eq(column, value)
    .maybeSingle()

  if (error) {
    console.warn(`[supabase] show access token lookup by ${column} failed: ${error.message}`)
    return ''
  }
  return (data?.access_token as string | undefined) ?? ''
}
